import type { MemoizedFn } from 'memoize-one';
import memoize from 'memoize-one';

import { getDwellTimeHelper } from '@confluence/analytics-web-client';

import type { DwellTimeHelperProvider } from './DwellTimeTracker.ts';
import { DwellTimeTracker } from './DwellTimeTracker.ts';
import type { DwellBaseData, DwellCallbackData } from './DwellTimeHelper.ts';

export const getDwellTimeTracker: MemoizedFn<(iframeDwell?: boolean) => Promise<DwellTimeTracker>> =
	memoize(async (iframeDwell?: boolean): Promise<DwellTimeTracker> => {
		const DwellTimeHelper = await getDwellTimeHelper();

		const provideDwellTimeHelper: DwellTimeHelperProvider = (
			sendDwellEvent: (data: DwellCallbackData) => void,
			dwellData: DwellBaseData,
			searchSessionId?: string,
		) => {
			return new DwellTimeHelper(
				sendDwellEvent,
				dwellData,
				searchSessionId,
				{},
				{
					iframeDwell,
				},
			);
		};

		return new DwellTimeTracker(provideDwellTimeHelper);
	});
